/**
 * El shell de las 15 vistas autenticadas.
 *
 * `UI-5`: el design system conserva el sidebar, la topbar y el drawer. La
 * navegación estructurada se compone aparte porque expresa secciones y
 * subítems que la lista plana de `NavItem` no puede representar.
 */
import type { ReactNode } from 'react'
import { AppShell } from '@mpfn/patterns'
import { Avatar, Button } from '@mpfn/ui'
import { BrandLockup } from '@mpfn/brand'
import { LogOut } from 'lucide-react'
import { useSesion } from '../sesion/contexto.js'
import type { Vista } from '../navegacion/rutas.js'
import { iniciales } from '../lib/formato.js'
import { NavegacionLateral } from './navegacion/NavegacionLateral.js'

export function Marco({ vistaActiva, children }: { vistaActiva: Vista; children: ReactNode }) {
  const { usuario, cerrarSesion } = useSesion()

  return (
    <AppShell
      brand={
        <BrandLockup
          tone="onBrand"
          size="sm"
          orientation="stacked"
          name="SIGFISC"
          description="Fiscalización de contrataciones"
        />
      }
      renderNavigation={({ closeNavigation }) => (
        <NavegacionLateral
          usuario={usuario}
          vistaActiva={vistaActiva}
          onNavegar={closeNavigation}
        />
      )}
      // `user` va a la TOPBAR, no al pie del sidebar: es donde lo monta el
      // `AppShell`. El boceto del inventario lo dibujaba abajo a la izquierda;
      // moverlo exigiría reimplementar el shell, que es justo lo que `UI-5`
      // prohíbe.
      user={
        <div className="sigfisc-usuario">
          <Avatar fallback={iniciales(usuario.nombre)} alt="" />
          <span className="sigfisc-usuario__datos">
            <span className="sigfisc-usuario__nombre">{usuario.nombre}</span>
            <span className="sigfisc-usuario__rol">{usuario.rol}</span>
          </span>
        </div>
      }
      actions={
        <Button
          variant="ghost"
          size="sm"
          onClick={() => {
            void cerrarSesion()
          }}
        >
          <LogOut size={16} aria-hidden="true" />
          Salir
        </Button>
      }
    >
      {children}
    </AppShell>
  )
}
